const topicItems = [
  { label: '高分神作', count: '3.2万讨论' },
  { label: '悬疑烧脑', count: '2.8万讨论' },
  { label: '国产佳片', count: '2.5万讨论' },
  { label: '韩剧热播', count: '2.1万讨论' },
  { label: '动漫精选', count: '1.9万讨论' },
  { label: '纪录片', count: '1.7万讨论' },
  { label: '经典修复', count: '1.5万讨论' },
  { label: '院线新片', count: '1.3万讨论' },
  { label: '午夜剧场', count: '1.2万讨论' },
  { label: '喜剧合集', count: '1.0万讨论' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
            <i className="ri-hashtag text-accent-600 text-lg"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">热门话题</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11">全网热议话题标签，找到你感兴趣的影片类型</p>

        <div className="flex flex-wrap gap-2 md:gap-3">
          {topicItems.map((topic) => (
            <div
              key={topic.label}
              className="group flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.label}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}